module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-detail",
    attrs: {
      "id": ("product_sku__" + (_vm.product.sku))
    }
  }, [_c('div', {
    staticClass: "wrap-container"
  }, [(false && _vm.isMainCampaign) ? _c('h1', {
    staticClass: "page-title text-center"
  }, [_vm._v(_vm._s(_vm.title))]) : _c('h1', {
    staticClass: "page-title page-title--campaign text-center px-2"
  }, [_vm._v("บริจาคให้โครงการ")]), _vm._v(" "), (true || !_vm.isMainCampaign) ? _c('h2', {
    staticClass: "text-center campaign-title"
  }, [_vm._v("\n      " + _vm._s(_vm.product.name) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "mx-auto text-center float-none"
  }, [(true || !_vm.isMainCampaign) ? _c('div', {
    staticClass: "text-center mb-3 text-blue text-lg m-0",
    domProps: {
      "innerHTML": _vm._s(_vm.product.description)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {}, [(_vm.ready) ? _c('div', [(_vm.product && _vm.product.sku) ? _c('product-list-item', {
    ref: "form",
    attrs: {
      "extraClasses": "product--inline",
      "product": _vm.product,
      "initialQuantity": 1,
      "cartMode": false,
      "showAttributes": true,
      "useCarousel": true,
      "titleAsLink": false,
      "showTimeBeforeAvailable": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product.notice) ? _c('div', {
    staticClass: "alert alert--danger text-left"
  }, [_c('strong', [_vm._v("หมายเหตุ")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.notice)
    }
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.ready) ? _c('div', [_c('loader')], 1) : _vm._e()])]), _vm._v(" "), _c('banner')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b201d732","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductDetail.vue
// module id = 737
// module chunks = 1